module.exports = __webpack_public_path__ + "assets/img/Mail.40d35571.png";